import { render } from "./AiReport.vue?vue&type=template&id=2a2e8500&ts=true"
import script from "./AiReport.vue?vue&type=script&lang=ts"
export * from "./AiReport.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__